// extracted by mini-css-extract-plugin
export default {"defaultLine":"#226b1e","defaultFill":"#e1ecda","grid":"#d8e4cb","dotStroke":"#fff","skeletonOverlay":"zpsP5cAPgROGbZ8k07Pr","sparklineSkeletonShimmer":"vYGxadG1Ss26rNxiCqem"};